export const MILLISECONDS_PER_SECOND = 1000;
